export const livePriceChange = async (data, thunkApi) => {
  try {
    const {
      limit,
      offset,
      category,
      brand,
      start_date,
      end_date,
      locations,
      action,
      diff_value,
      source,
      page,
      search,
    } = data;

    const { user } = thunkApi.extra.apiService;

    let response;
    if (page == "dashboard") {
      response = await user.get("/price-change/product", {
        params: {
          source,
          limit: 10,
        },
      });
    } else {
      response = await user.get("/price-change/product", {
        params: {
          limit,
          offset,
          source,
          category,
          start_date,
          end_date,
          locations,
          action,
          brand,
          diff_value,
          title: search,
        },
      });
    }
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
